import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteSTypeMutation} from 'api';
import {useSnackbar} from 'notistack';

function STypeDeleteIconButton({sTypeId}) {
  const [deleteSType, deleteSTypeResult] = useDeleteSTypeMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteSType(sTypeId).unwrap();
      enqueueSnackbar('Sourcing Type deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting Sourcing Type`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete SType</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Type?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteSTypeResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteSTypeResult.isLoading}
            color="error"
            endIcon={deleteSTypeResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteSTypeResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default STypeDeleteIconButton;
